import DocumentUpload from '@/app/common/components/DocumentUpload'
import FamilyWizardLayout from '@/app/pages/family_application/FamilyWizardLayout.tsx'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DocumentReviewPage } from './DocumentReview'

type Steps = 'document_capture' | 'document_review'

export const DocumentCapturePage = () => {
  const [image, setImage] = useState<File | null>()
  const [step, setStep] = useState<Steps>('document_capture')
  const { t: translate } = useTranslation()

  if (step === 'document_review' && image) {
    return <DocumentReviewPage image={image} />
  }

  return (
    <FamilyWizardLayout>
      <FamilyWizardLayout.Header>
        <h1>{translate('upload_income_document')}</h1>
      </FamilyWizardLayout.Header>
      <FamilyWizardLayout.Content className=" items-center w-full  justify-center">
        <DocumentUpload
          isPdfAllowed={true}
          onUpload={(file) => {
            setImage(file[0])
            setStep('document_review')
          }}
        />
      </FamilyWizardLayout.Content>
    </FamilyWizardLayout>
  )
}
